<template>
  <section>
    <div v-if="loading">

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              Editar Campaña
          </h2>
        </div>
        <form  @submit.prevent="updateCampaign">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-4 sm:col-span-4">
              <label>Nombre:</label>
              <input @input="updateValue('name',$event)" type="text" class="input w-full border mt-2 flex-1"
                :value="campaign.name" required>
          </div>
          <div class="col-span-4 sm:col-span-4">
              <label>Proyecto</label>
              <select class="input w-full border mt-2" @input="updateValue('project_id',$event)"
                  :value="campaign.project_id" required>
                  <option disabled>Seleccione el proyecto</option>
                  <option v-for="project in projects" v-bind:value="project.id">
                    {{project.name}}
                  </option>
              </select>
          </div>
          <div class="col-span-4 sm:col-span-4">
              <label>Estado</label>
              <select class="input w-full border mt-2" @input="updateValue('status',$event)"
                  :value="campaign.status" required>
                  <option disabled>Seleccione el usuario</option>
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
              </select>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" @click="closeEditCampaign()" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Modificar</button>
        </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- Filter -->
      <h2 class="intro-y text-lg font-medium mr-auto mt-8">
          Campañas
      </h2>
      <div class="intro-y mt-6 flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
            <a data-target="#campaign" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Crear Campaña</a>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5">
          <div class="intro-y col-span-12 md:col-span-6" v-for="campaign in campaigns">
              <div class="box">
                  <div class="flex flex-col lg:flex-row items-center p-5">
                      <div class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
                          <a href="#" class="font-medium">{{campaign.name}}</a>
                          <div class="text-gray-600 text-xs">{{campaign.status === 0 ? 'Inactivo' : 'Activo'}} - {{campaign.project.name}}</div>
                      </div>
                      <div class="flex mt-4 lg:mt-0">
                          <button @click="editCampaign(campaign)" class="button button--sm text-white bg-theme-1 mr-2">
                            <app-icon v-bind:name="'edit'" v-bind:classname="'w-4 h-4'"></app-icon>
                          </button>
                          <button @click="removeCampaign(campaign)" class="button button--sm text-gray-700 border border-gray-300">
                            <app-icon v-bind:name="'trash'" v-bind:classname="'w-4 h-4'"></app-icon>
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- END: List -->

    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>

    <!-- Modal -->
    <div class="modal" id="campaign">
      <div class="modal__content modal__content--sm">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              Crear Campaña
          </h2>
        </div>
        <form @submit.prevent="createCampaign">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-12 sm:col-span-12">
              <label>Nombre:</label>
              <input  type="text" class="input w-full border mt-2 flex-1" v-model="campaign.name" required>
          </div>
          <div class="col-span-12 sm:col-span-12">
              <label>Proyecto</label>
              <select class="input w-full border mt-2" v-model="campaign.project_id" required>
                  <option disabled>Seleccione el proyecto</option>
                  <option v-for="project in filteredProjects" :value="project.id" :key="`campaign-${project.id}`">
                    {{project.name}}
                  </option>
              </select>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
        </div>
        </form>
      </div>
  </div>
  <!-- Modal End -->

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListCampaign',
  data () {
    return {
      loading: false,
      boxedit: false,
      campaign: {
        name: '',
        project_id: '',
        status: '',
        entity: 'campaign'
      },
      campaign_current: {}
    }
  },
  computed: {
    ...mapGetters({
      campaigns: 'getCampaigns',
      projects: 'getProjects',
    }),
    filteredProjects: function() {
      return this.projects.filter((item) => {
        if(item.account_id == localStorage.session_account)
        {
          return item;
        }
      })
    }
  },
  async beforeMount () {
    let query = `account_session=${localStorage.session_account}`
    try {
      await this.getList(['campaign', query])
      this.getList(['project', query])

      this.loading = true
    } catch (error) {}
  },
  methods: {
    createCampaign () {
      var vm = this
      window.$('#create').button('loading')
      vm.store(vm.campaign).then(item => {
        window.$('#campaign').modal('hide')
        vm.campaign = { name: '', entity: 'campaign' }
        vm.$router.replace(vm.$route.query.redirect || '/admin/campaigns')
      })
      .catch(error => {
        window.$('#create').button('reset')
        vm.campaign = { name: '', entity: 'campaign' }
      })
    },
    removeCampaign: function (value) {
      var vm = this
      vm.form = {
        id : value.id,
        entity : 'campaign'
      }
      vm.loading = false
      vm.remove(vm.form).then(item => {
        vm.loading = true
        vm.$router.replace(vm.$route.query.redirect || '/admin/campaigns')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    editCampaign: function (value) {
      this.boxedit = true
      this.campaign = value
    },
    closeEditCampaign: function () {
      this.boxedit = false
      this.campaign_current = {}
    },
    updateCampaign: function (value) {
      var vm = this
      vm.form = {
        id : vm.campaign.id,
        entity : 'campaign',
        name: vm.campaign_current.name,
        project_id: vm.campaign_current.project_id,
        status: vm.campaign_current.status
      }
      vm.loading = false
      vm.update(vm.form).then(item => {
        vm.loading = true
        vm.boxedit = false
        vm.campaign = { name: '', entity: 'campaign' }
        vm.$router.replace(this.$route.query.redirect || '/admin/campaigns')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    updateValue (attribute, e) {
      this.campaign_current[attribute] = e.target.value
    },
    ...mapActions([
      'getAll',
      'getList',
      'remove',
      'store',
      'update'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// CampaignsTeam.vue?0d869ff0